import { render, staticRenderFns } from "./DialCampaign.vue?vue&type=template&id=02937885"
import script from "./DialCampaign.vue?vue&type=script&lang=js"
export * from "./DialCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports